import { VolummType } from 'consts/data';
import { isEmpty } from 'lodash';

class VoluumModel {
  static parseRequestUpdate(body) {
    const { voluumOption } = body;
    const isMessageID = voluumOption === VolummType.MessageID;
    const isPhoneMapping = voluumOption === VolummType.PhoneMapping;

    return {
      phone: isPhoneMapping ? body.voluumMappingPhone : '',
      campaignName: isPhoneMapping ? body.voluumMappingCampaignName : '',
      did: isPhoneMapping ? body.voluumMappingDid : '',
      domain: isPhoneMapping ? body.voluumMappingDomain : '',
      creative: isPhoneMapping ? body.voluumMappingCreative : '',
      route: isPhoneMapping ? body.voluumMappingRoute : '',
      //* Message ID
      messageId: isMessageID ? body.voluumMessageId : '',
    };
  }

  static isNotHasVoluumConfig(voluum) {
    return isEmpty(voluum) || !voluum?.accessId;
  }
}

export default VoluumModel;
